export default __webpack_public_path__ + "static/media/payment-method-google-pay-grey-icon.0b80e3fb.svg";